module.exports = {
      id: "comm-album-usage",
      viewBox: "0 0 230.223 54.026",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-album",
      toString: function () {
        return this.url;
      }
    }